import { render, staticRenderFns } from "./form-digikey.vue?vue&type=template&id=55c115bf&"
import script from "./form-digikey.vue?vue&type=script&lang=js&"
export * from "./form-digikey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports